import { Box, styled } from "@mui/material";
import { StyledComponentProps } from "../../models/global/Types";

export const StyledMaterials = styled(Box)(
  ({ theme }: StyledComponentProps) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
    maxHeight: "100vh",
    overflowY: "scroll",
    paddingInline: "5rem",
    ".materialWrapper": {
      width: "90%",
      borderRadius: "5px",
      padding: "1rem",
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      justifyContent: "center",
      gap: "1rem",
    },
    ".filterBar": {
      display: "flex",
      width: "80%",
      justifyContent: "space-between",
      alignItems: "center",
      input: {
      width: "30rem",
    },
      ".actionButtons": {
        display: "flex",
        gap: "1rem",
        ".qrButton": {
          background: theme.contrast.lighter,
          color: theme.color.dark
        }
      },
  
    },
    
  })
);
